import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { Workflows } from '../model/workflows.model';
import { WorkflowsService } from '../service/workflows.service';

@Component({
    selector: 'edit-workflows',
    templateUrl: './edit-workflows.component.html',
    styleUrls: ['./edit-workflows.component.scss']
})
export class EditWorkflowsComponent implements OnInit {
    workflow: Workflows;
    workflowsId: number;

    // Tab labels
    selectedIndex: number = 0;

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(private workflowsService: WorkflowsService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            this.workflowsId = parseInt(this.activatedRoute.snapshot.paramMap.get('id')!);
        }
    }

    ngOnInit(): void {
        this.getWorkflow();
    }

    getWorkflow() {
        this.isLoading = true;

        this.workflowsService.show(this.workflowsId).subscribe({
            next: (res) => {
                this.workflow = res.workflow;
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error retrieving Workflow.' };
            },
            complete: () => {
                // Display results
                this.isLoading = false;
            }
        });
    }
}
